import check from '../libraries/check-types-ext';
import AppError from '../libraries/AppError';
import SectionHeaderElement from './SectionHeaderElement';
import * as _ from 'lodash';
import GridBlockElement from './GridBlockElement';
import { NodeElements } from '../plugins/commonTypes/CategoryTypes';
export default class Category {
    constructor(categoryNode, productMapper, options = {}) {
        this.categoryNode = categoryNode;
        this.options = options;
        check.object.orFail(categoryNode, 'categoryNode');
        check.object.orFail(productMapper, 'mapper');
        Object.assign(this, categoryNode);
        this.isGBOCategory = false;
        const elements = Array.isArray(categoryNode.elements) ? categoryNode.elements : [];
        this.elements = elements.map((node) => {
            if (node.objType === 'SectionHeaderElement') {
                return new SectionHeaderElement(node);
            }
            else if (node.objType === 'GridBlockElement') {
                return new GridBlockElement(node, productMapper);
            }
            else if (NodeElements.includes(node.objType)) {
                return node;
            }
            else {
                throw AppError.CodingError('Should never happen: ').addData('node', node);
            }
        });
        this.rawObject = _.omit(categoryNode, ['id']);
        if (!options.skipCategoryRegister) {
            productMapper.registerCategory(this);
        }
    }
}
